var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveFloatingIps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/left-sidebar/ic floating ip",
    clipPath: "url(#clip0_9146_76181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic floating ip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6663 1.66406H12.8447C12.1022 1.66406 11.7305 2.56156 12.2555 3.08656L13.4047 4.23573L10.0413 7.59906C8.93967 8.70073 8.33301 10.1657 8.33301 11.7241V14.1641H11.6663V11.7232C11.6663 11.0557 11.9263 10.4274 12.398 9.9549L15.7613 6.59156L16.9105 7.74073C17.4355 8.26656 18.333 7.8949 18.333 7.1524V3.33073C18.333 2.4099 17.5872 1.66406 16.6663 1.66406Z",
    fill: "#65B2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M7.15527 1.66406C7.89777 1.66406 8.26914 2.56191 7.74414 3.08691L6.59473 4.23535L9.95898 7.59863C11.0531 8.6927 11.6669 10.1763 11.667 11.7236V17.4971C11.667 17.957 11.2938 18.3309 10.834 18.3311H9.16699C8.70699 18.3311 8.33398 17.9571 8.33398 17.4971V11.7227C8.33398 11.0602 8.0699 10.4242 7.60156 9.95508L4.23828 6.5918L3.08984 7.74121C2.56484 8.26621 1.66699 7.89484 1.66699 7.15234V3.33105C1.66699 2.41022 2.41315 1.66406 3.33398 1.66406H7.15527Z",
    fill: "#FFFFFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_76181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#2894FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFloatingIps);
export default __webpack_public_path__ + "static/media/active-floatingIps.c72c8296a7d84cc3530cedbfc95717f2.svg";
export { ForwardRef as ReactComponent };